import { getDataBlockFieldValue } from "@/domains/datablocks/hooks/useDataBlockField";
import {
  ContentType,
  DataBlockListResponse,
  DataBlockResponse,
} from "@/redux/datablocks/types";
import { useDataBlockRelatedData } from "@/domains/datablocks/hooks/useDataBlockRelatedData";

import { BaseUserResponse } from "@/redux/users/types";

export function getEvidenceTitle(
  dataBlock: DataBlockResponse | DataBlockListResponse | undefined,
): string | undefined {
  return getDataBlockFieldValue<string>(dataBlock, "title");
}

export function getEvidenceContributors(
  dataBlock: DataBlockResponse | DataBlockListResponse | undefined,
): number[] {
  return getDataBlockFieldValue<number[]>(dataBlock, "contributors") || [];
}

export function getEvidenceLanguages(
  dataBlock: DataBlockResponse | DataBlockListResponse | undefined,
): number[] {
  return getDataBlockFieldValue<number[]>(dataBlock, "languages") || [];
}

export function useEvidenceContributors(
  dataBlock: DataBlockResponse | undefined,
  options?: { rawValue?: boolean },
) {
  const contributorIds = getEvidenceContributors(dataBlock);

  const { data: contributors, isLoading } = useDataBlockRelatedData(
    contributorIds || [],
    ContentType.Users,
  ) as { data: BaseUserResponse[] | undefined; isLoading: boolean };

  return {
    data: (options?.rawValue ? contributorIds : contributors) || [],
    isLoading,
  };
}
